<template>
  <div>

    <md-card md-with-hover>

      <md-card-header>
        <div class="md-title">COMUNICAZIONE SICURA</div>
        <div class="md-subhead">Non sei autorizzato ad accedere a questa pagina.</div>
      </md-card-header>

    </md-card>
  </div>
</template>

<script>

export default {
  name: 'unauthorized'

}
</script>

<style lang="scss" scoped>
  .md-card{
    width: 60%;
    margin: 20px auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/Unauthorized.vue